import React from 'react';
import { useGame } from '@/app/providers/GameContextProvider';
import { GameMode } from '@/lib/types/common/GameMode';
import GameModeConfigDescription from './GameModeConfigDescription';
import GameModeConfigExpansions from './GameModeConfigExpansions';
import GameModeConfigSeparator from './GameModeConfigSeparator';
import GameModeConfigMapTypes from './GameModeConfigMapTypes';
import GameModeConfigAdvancedSettings from './GameModeConfigAdvancedSettings';
import GameModeConfigActions from './GameModeConfigActions';

const GameModeConfigPanel = () => {
    const { gameState } = useGame();
    const isDaily = gameState?.gameMode === GameMode.DAILY;
    return (
        <div className="md:w-[550px] flex flex-col justify-between">
            <div className="flex flex-col gap-3">
                <GameModeConfigDescription />
                <GameModeConfigSeparator /> {/* Separator */}
                {/* Hide expansions and map types for Daily mode - they are locked to all */}
                {!isDaily && (
                    <>
                        <GameModeConfigExpansions />
                        <GameModeConfigMapTypes />
                        <GameModeConfigSeparator /> {/* Separator */}
                    </>
                )}
                <GameModeConfigAdvancedSettings />

            </div>
            <GameModeConfigActions />
        </div>
    );
}

export default GameModeConfigPanel